import React, { useEffect } from "react";
import * as yup from 'yup';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, FormGroup, Label, Input, FormFeedback, Alert } from "reactstrap";

const schema = yup.object().shape({
  credits: yup
    .number()
    .typeError('Credits must be a number')
    .required('Credits amount is required')
    .positive('Credits must be a positive number')
    .integer('Credits must be a whole number')
    .min(1, 'Credits must be at least 1')
});

const AddContactCreditModal = ({ open, onClose, user, onSubmit }) => {
  const { control, reset, handleSubmit, formState: { isSubmitting, errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      credits: ''
    }
  });

  useEffect(() => {
    if (open) {
      reset({ credits: '' });
    }
  }, [open, reset]);

  const handleFormSubmit = async (values) => {
    try {
      await onSubmit(user, parseInt(values.credits));
      reset();
      onClose();
    } catch (e) {
      console.error('Error adding contact credits:', e);
    }
  };

  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <span style={{ fontSize: "18px", fontWeight: "700" }}>
          Add Contact Credits
        </span>
      </ModalHeader>
      <ModalBody>
        {user && (
          <Alert color="info" className="mb-3">
            <div><strong>User:</strong> {user.name || 'N/A'}</div>
            <div><strong>Email:</strong> {user.email}</div>
            {user.organizationName && (
              <div><strong>Organization:</strong> {user.organizationName}</div>
            )}
            {user.organizationType && (
              <div><strong>Organization Type:</strong> {user.organizationType}</div>
            )}
            <div><strong>Current Credits:</strong> {user.totalContactCredits || 0}</div>
          </Alert>
        )}

        <FormGroup>
          <Label>Contact Credits to Add *</Label>
          <Controller
            name="credits"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Input
                type="number"
                value={value}
                onChange={onChange}
                invalid={!!errors?.credits}
                placeholder="Enter number of credits"
                min="1"
                step="1"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleSubmit(handleFormSubmit)();
                  }
                  // Prevent decimal point and negative sign
                  if (e.key === '.' || e.key === '-' || e.key === 'e' || e.key === 'E') {
                    e.preventDefault();
                  }
                }}
              />
            )}
          />
          {errors?.credits && (
            <FormFeedback style={{ display: 'block' }}>{errors.credits.message}</FormFeedback>
          )}
        </FormGroup>

        {/* <div className="text-muted" style={{ fontSize: '12px' }}>
          <strong>Note:</strong> These credits will be added to the {user?.organizationId ? 'organization' : 'user'}'s current balance.
        </div> */}
      </ModalBody>
      <ModalFooter>
        <button
          className='btn btn-outline-dark'
          onClick={onClose}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <Button
          color="primary"
          onClick={handleSubmit(handleFormSubmit)}
          type='submit'
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <Spinner size="sm" color="light" />
          ) : (
            "Add Credits"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddContactCreditModal;
